import React from 'react'

const About = () => {
  return (
    <div name="about" className="w-full h-screen bg-gradient-to-b from-gray-800 to-black text-white">
        <div className="max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full">
            <div className='pb-8'>
                <p className="text-4xl font-bold inline border-b-4 border-gray-500">
                    About
                </p>
            </div>
                <p className="text-xl mt-20">
                As a recent graduate with a B.Tech. degree in Computer Science and Engineering (2023 batch) from KIET Group Of Institutions, Ghaziabad (Delhi-NCR), I am a dedicated and ambitious fresher seeking to make a positive impact in the field of technology.
                </p>

                <br/>

                <p className="text-xl">
                With over 2 years of internship experience as a Software Developer, I have honed my skills in a diverse set of technologies, including Python, Django, MySQL, Javascript, React js, AWS, Devops, Git, C++ and many more. My passion for programming extends to competitive programming, where I actively participate to enhance my problem-solving abilities.
                </p>

                {/* <br/>

                <p className="text-xl">
                I am enthusiastic about embracing new challenges and staying up-to-date with emerging technologies to excel in my role. With a strong foundation in computer science and a drive to learn, I am ready to contribute my skills and dedication to any technology-driven opportunity.

                I am excited about the prospect of joining a dynamic team and contributing to innovative projects. I believe my adaptability, creativity, and determination make me a valuable addition to any organization.
                </p> */}
            
        </div>
    </div>
  )
}

export default About